module.exports = __webpack_public_path__ + "media/BG_Login.0fb2133b.mp4";